import { SettingOutlined } from "@ant-design/icons";
import { Button, Card, Flex, Typography } from "antd";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../pages/compliance/compliance.module.scss";

type Props = {
  icon: ReactNode;
  title: string;
  description: ReactNode;
  ctaLabel?: string;
  ctaTo?: string;
};

const ComplianceEmptyState = ({
  icon,
  title,
  description,
  ctaLabel = "Add and Manage Rules",
  ctaTo = "/compliance/manage-rules",
}: Props) => {
  const navigate = useNavigate();
  return (
    <Card className={styles.compliance__emptyState}>
      <Flex vertical align="center" gap={16} style={{ textAlign: "center", padding: "48px 24px" }}>
        <div className={styles.compliance__emptyState_icon}>{icon}</div>
        <Flex vertical gap={6} style={{ maxWidth: 560 }}>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
          <Typography.Text style={{ color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>{description}</Typography.Text>
        </Flex>
        <Button type="primary" icon={<SettingOutlined />} onClick={() => navigate(ctaTo)}>
          {ctaLabel}
        </Button>
      </Flex>
    </Card>
  );
};

export default ComplianceEmptyState;
